import * as types from '../../actions';
const initialState = {
    items: [],
    status:0,
    item:{
        id:'',
        name:'',
        short_description:''
    },
    activity:'',
    count:'',
    errorData:''    
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {
        case types.OTHER_EXP_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data,
                    status: response.status,
                    activity:types.OTHER_EXP_LIST_SUCCESS,
                    count:response.data.length
                };
            }else{
                return {
                    ...state,
                    status: response.status,     
                    activity:types.OTHER_EXP_LIST_ERROR,                            
                };
            }       

        case types.OTHER_EXP_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.OTHER_EXP_ADD_SUCCESS,
                }   
            }else{
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity:types.OTHER_EXP_ADD_ERROR,
                }   
            }
        case types.OTHER_EXP_EDIT_SUCCESS:     
            if(response.status===200){     
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        name: response.data.name,
                        short_description: response.data.short_description
                    },
                    status: response.status,
                    activity:types.OTHER_EXP_EDIT_SUCCESS,               
                }     
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.OTHER_EXP_EDIT_ERROR,         
                }   
            }  
       
        case types.OTHER_EXP_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items:state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity:types.OTHER_EXP_UPDATE_SUCCESS,         
                }    
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.OTHER_EXP_UPDATE_ERROR, 
                    errorData: response.data,        
                }    
            }       

        case types.OTHER_EXP_DELETE_SUCCESS:
            const id = response.data.id;     
            if(response.status===200){
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),               
                    status: response.status,
                    activity:types.OTHER_EXP_DELETE_SUCCESS,   
                }       
    
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.OTHER_EXP_DELETE_ERROR,  
                    errorData: response.data, 
                }       
    
            }           
            
        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name:'',
                    short_description:'',
                },
                activity:'',
                status:0               
            }  

        default:
            return state;
    }
  };